<script lang="ts">
  import clsx from 'clsx';
  import { Button } from '@athena-lib/Button';
  import type { SpecsTableProps } from './types';

  const { specs, tags, valueSnippet, action, actionArg }: SpecsTableProps<unknown> = $props();

  let selectedTag = $state(tags[0]);
  let currentSpecs = $derived.by(() =>
    specs.filter((spec) => spec.tags.includes(selectedTag?.value)),
  );

  function elementAction(node: HTMLDivElement) {
    if (action) {
      return action(node, actionArg!);
    }
  }

  function splitArray<T>(array: T[], chunkSize: number): T[][] {
    const chunks = [];
    for (let i = 0; i < array.length; i += chunkSize) {
      chunks.push(array.slice(i, i + chunkSize));
    }
    return chunks;
  }
</script>

<div use:elementAction class="flex flex-col gap-4">
  <div class="relative">
    <div class="absolute right-0 aspect-square h-full bg-gradient-to-l from-st-white"></div>
    <ul
      class="flex gap-3 overflow-scroll pb-2 pr-8 scrollbar-thin scrollbar-track-st-white scrollbar-thumb-st-gray-100 scrollbar-track-rounded-full scrollbar-thumb-rounded-full"
    >
      {#each tags as tag}
        <li>
          <Button
            onClick={() => (selectedTag = tag)}
            color={selectedTag.value === tag.value ? 'brand' : 'white'}
            size="small"
          >
            {tag.name}
          </Button>
        </li>
      {/each}
    </ul>
  </div>
  <div class="block gap-medium md:flex">
    {#each splitArray(currentSpecs, Math.ceil(currentSpecs.length / 2)) as specsChunk, i}
      <div class="w-full">
        <table class="w-full">
          <tbody>
            {#each specsChunk as spec}
              <tr
                class={clsx(
                  i === 0 ? 'odd:bg-st-gray-200' : 'even:bg-st-gray-200',
                  'md:odd:bg-st-gray-200 md:even:bg-transparent',
                )}
              >
                <td
                  class="block min-h-4 w-full hyphens-auto p-3 pb-0.5 align-top font-bold sm:inline-block sm:w-1/2 sm:pb-3 lg:w-2/5"
                  >{spec.label}</td
                >
                <td
                  class="block min-h-4 w-full p-3 pt-0.5 align-top sm:inline-block sm:w-1/2 sm:pt-3"
                >
                  {#if valueSnippet}
                    {@render valueSnippet(spec.value)}
                  {:else}
                    {spec.value}
                  {/if}
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      </div>
    {/each}
  </div>
</div>
